import "./Header.scss"
import React from "react"
import classnames from "classnames"
import shadowTop from "../assets/content-shadow-top.png"
import shadowLeft from "../assets/content-shadow-left.png"
import shadowRight from "../assets/content-shadow-right.png"

const Header = ({ title, children }) => {
  return (
    <header className={classnames("Header", !children && "Header-minimal")}>
      <h1 className="Header_title">{title}</h1>
      {children}
      <div className="Header_shadow">
        <img
          className="Header_shadow-left"
          src={shadowLeft}
          role="presentation"
        />
        <img
          className="Header_shadow-top"
          src={shadowTop}
          role="presentation"
        />
        <img
          className="Header_shadow-right"
          src={shadowRight}
          role="presentation"
        />
      </div>
    </header>
  )
}

Header.displayName = "Header"

export default Header



// WEBPACK FOOTER //
// ./src/lib/Header.js